
export const zipCodeAvailable = [
    "03820", "03240", "03230", "03400", "03560", "03610", "03840", "03010", "03710", "03940",
    "03540", "03640", "03100", "03103", "03104", "03590", "03740", "03340", "03630", "03920",
    "03100", "03520", "03430", "03650", "03930", "03420", "03580", "03910", "03510", "03810", 
    "03023", "03020", "03500", "03440", "03720", "03620", "03000", "03303", "03570", "03300",
    "03410", "03320", "03900", "03730", "03800", "03660", "03310", "03700", "03200", "03600",
    "03530", "03330", "03550"
]